import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { config } from '@/store';
import { ElMessageBox } from 'element-plus';
import i18n from '@/i18n';
import tagApi, { tagItemType } from '@/api/tag';


export default /*#__PURE__*/_defineComponent({
  __name: 'manga-tag-box',
  props: ['mangaId', 'tags'],
  emits: ['update_tags'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = i18n.global;

const drawer = ref(false);
const isCollect = ref(false);
const editTagsDialog = ref(false);

let tagList = ref<tagItemType[]>([]);
let checkedTagList = ref<tagItemType[]>([]);

let noCheckedTagList = computed<tagItemType[]>(() => {
    let arr: tagItemType[] = [];
    const checkedTagListNames = checkedTagList.value.map((i) => i.tagId);

    tagList.value.forEach(element => {

        if (!checkedTagListNames.includes(element.tagId)) arr.push(element);
    });

    return arr;
});

const props = __props;
const emit = __emit;

onMounted(async () => {
    tagList.value = await tagApi.get_nopage();
    checkedTagList.value = props.tags;
});

/**
 * @description: 更新标签状态
 * @return {*}
 */
async function update_tags_state() {
    const tags = await tagApi.get_manga_tag(props.mangaId);
    checkedTagList.value = tags;
    // 向上更新详情页的tags列表
    emit('update_tags', tags);
}

/**
 * @description: 增加漫画标签
 * @param {*} tagItem
 * @return {*}
 */
async function add_manga_tag(tagItem: tagItemType) {
    await tagApi.add_manga_tag(props.mangaId, tagItem.tagId);
    update_tags_state();
}

/**
 * @description: 移除漫画标签
 * @param {*} mangaTagId
 * @return {*}
 */
async function remove_tag(mangaTagId: number) {
    await tagApi.remove_manga_tag(mangaTagId);
    update_tags_state();
}

const __returned__ = { t, drawer, isCollect, editTagsDialog, get tagList() { return tagList }, set tagList(v) { tagList = v }, get checkedTagList() { return checkedTagList }, set checkedTagList(v) { checkedTagList = v }, get noCheckedTagList() { return noCheckedTagList }, set noCheckedTagList(v) { noCheckedTagList = v }, props, emit, update_tags_state, add_manga_tag, remove_tag }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})